import React from 'react';
import docs from '../../../assets/docs.jpg';
import stathoscope from '../../../assets/stathoscope.jpg';
import pill from '../../../assets/pill.jpg';

const Service = () => {
    return (
        <div className='my-28'>
            <div className='text-center pb-12'>
                <h3 className='text-accent py-3 text-5xl uppercase'>Our Services</h3>
                <h2 className='text-3xl'>Services We Provide</h2>
            </div>
            <div className='grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10'>
                <div className="card lg:max-w-lg bg-base-100 shadow-xl">
                    <figure className="px-10 pt-10">
                        <img src={docs} alt="Shoes" className="rounded-xl" />
                    </figure>
                    <div className="card-body items-center text-center mt-24">
                        <h2 className="text-3xl">Consultation</h2>
                        <p>Lorem Ipsum is simply dummy printing and typesetting indust Ipsum has been the</p>
                    </div>
                </div>
                <div className="card lg:max-w-lg bg-base-100 shadow-xl">
                    <figure className="px-10 pt-10">
                        <img src={stathoscope} alt="Shoes" className="rounded-xl" />
                    </figure>
                    <div className="card-body items-center text-center">
                        <h2 className="text-3xl">Treatment</h2>
                        <p>Lorem Ipsum is simply dummy printing and typesetting indust Ipsum has been the</p>
                    </div>
                </div>
                <div className="card lg:max-w-lg bg-base-100 shadow-xl">
                    <figure className="px-10 pt-10">
                        <img src={pill} alt="Shoes" className="rounded-xl" />
                    </figure>
                    <div className="card-body items-center text-center mt-40">

                        <h2 className="text-3xl">Pharmacy</h2>
                        <p>Lorem Ipsum is simply dummy printing and typesetting indust Ipsum has been the</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Service;